/* eslint-disable */

<template>
  <div>
    <div>
      <span
        class="mt-2 mb-3 ml-1"
        v-bind:class="{ invisible: this.selectedRequests.length < 1 }"
        style="font-weight: bold; font-size: 18px"
        >{{ this.selectedRequests.length > 0 && this.selectedRequests.length }}
        {{ this.selectedRequests.length > 1 ? "requests" : "request" }} selected
      </span>
      <br />
      <br />
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div>
          <!-- Example split danger button -->
          <div class="btn-group">
            <button
              :disabled="(selectedItemsCount() < 1 && showExport != true)"
              type="button"
              class="
                btn btn-outline-info
                dropdown-toggle dropdown-toggle-split
                no-default-icon
              "
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Actions <i class="fas fa-chevron-circle-down ml-2"></i>
            </button>
            <div class="dropdown-menu">
              <a v-bind:class="{ disabled: selectedItemsCount() < 1, clickable: selectedItemsCount() > 0 }" class="dropdown-item" @click="clearSelectedItems()"
                ><i class="fas fa-ban mr-2"></i>Clear Selections
              </a>
              <div class="dropdown-divider"></div>
              <a v-bind:class="{ disabled: selectedItemsCount() < 1, clickable: selectedItemsCount() > 0 }" class="dropdown-item" @click="deleteSelectedItems()"
                ><i class="fas fa-trash-alt mr-2"></i> Delete Selected Rows
              </a>
              <a v-bind:class="{ disabled: selectedItemsCount() < 1, clickable: selectedItemsCount() > 0 }" class="dropdown-item" @click="showUpdateZone()"
                ><i class="fas fa-pencil-alt mr-2"></i> Update Zone for Selected
                Rows</a
              >
              <div v-if="showExport == true" class="dropdown-divider"></div>
              <a
                v-if="showExport == true"
                class="dropdown-item clickable"
                @click="exportRequests()"
                ><i class="fas fa-file-export mr-2"></i>Export Data
              </a>
            </div>
          </div>
        </div>
        <div>
          <div class="form-group">
            <input
              type="Search"
              class="form-control"
              aria-describedby="searchBar"
              placeholder="Search"
              v-model="searchVal"
            />
          </div>
        </div>

        <div style="float: right">
          <span class="mt-2 mr-2">Requests per Page: </span
          ><select
            class="custom-select"
            style="display: inline; width: 70px"
            v-model="totalItemsPerPage"
            v-on:change="onItemCountChange"
          >
            <option :value="5">5</option>
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="30">30</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>

      <table class="table table-hover" v-if="shortTable != true">
        <thead>
          <tr>
            <th scope="col">Requested</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col">Type</th>
            <th scope="col">Desc.</th>
            <th scope="col">House</th>
            <th scope="col">Street</th>
            <th scope="col">City</th>
            <th scope="col">Zip</th>
            <th scope="col">Zone</th>
            <th scope="col">Modify</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="clickable"
            v-for="request in curateData(requests)"
            :key="request.id"
            v-bind:class="{
              'highlight-request':
                !(request.req_zone && request.req_zone != '') &&
                !isSelectedRow(request.id),
              'selected-request': isSelectedRow(request.id),
            }"
            @click="toggleRowIsSelected(request.id)"
          >
            <td>{{ request.timestamp }}</td>
            <td>
              {{ request.req_contact_first }} {{ request.req_contact_last }}
            </td>
            <td>{{ request.req_email }}</td>
            <td>{{ formatPhoneNumber(request.req_phone) }}</td>
            <td>{{ request.req_type }}</td>
            <td>
              <div class="word-wrap">{{ request.req_description }}</div>
            </td>
            <td>{{ request.req_street_number }}</td>
            <td>{{ request.req_street_name }}</td>
            <td>{{ request.req_city }}</td>
            <td>{{ request.req_zip }}</td>
            <td>{{ request.req_zone }}</td>
            <td>
              <div class="column">
                <button
                  type="button"
                  class="btn bg-primary btn-sm mb-2"
                  v-on:click.stop="editProduct(request)"
                >
                  <i class="far fa-edit" style="color: #fff"></i></button
                ><br />
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  v-on:click.stop="deleteProduct(request)"
                >
                  <i style="padding: 0px 2px" class="fas fa-trash-alt"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-hover" v-if="shortTable == true">
        <thead>
          <tr>
            <th scope="col">Requested</th>
            <th scope="col">Type</th>
            <th scope="col">Location</th>
            <th scope="col">Zone</th>
            <th scope="col">Modify</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="clickable"
            v-for="request in curateData(requests)"
            :key="request.id"
            v-bind:class="{
              'highlight-request':
                !(request.req_zone && request.req_zone != '') &&
                !isSelectedRow(request.id),
              'selected-request': isSelectedRow(request.id),
            }"
            @click="toggleRowIsSelected(request.id)"
          >
            <td>{{ request.timestamp }}</td>
            <td>{{ request.req_type }}</td>
            <td>{{ request.req_location }}</td>
            <td>{{ request.req_zone }}</td>
            <td>
              <div class="column">
                <button
                  type="button"
                  class="btn bg-primary btn-sm mr-2"
                  v-on:click.stop="editProduct(request)"
                >
                  <i class="far fa-edit" style="color: #fff"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm mr-2"
                  v-on:click.stop="deleteProduct(request)"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-success btn-sm"
                  v-on:click.stop="copyRequest(request)"
                >
                  <i class="fas fa-clone"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        ref="page"
        :itemsPerPage="totalItemsPerPage"
        :maxiumumItems="getDataSize()"
        :updatePage="updatePage"
        :page="page"
      />
    </div>
    <div
      class="modal fade"
      id="product"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editLabel">Bulk Trash Request</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Bulk Trash Type -->
            <div>
              <p class="ml-0 mb-1 text-muted">Bulk Type</p>
              <select
                v-model="request.req_type"
                class="form-control mb-2"
                required
              >
                <option
                  v-for="type in sortBulkTypes(bulkTypes, true)"
                  :key="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>

            <!-- Assigned Zone -->
            <p class="ml-0 mb-1 mt-3 text-muted">Assigned Zone</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Zone (leave blank if unsure)"
              v-model="request.req_zone"
            />

            <!-- Bulk Items Description -->
            <p class="ml-0 mb-1 mt-3 text-muted">Bulk Item Description</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Item description (chair, washing machine, computer, etc.)"
              v-model="request.req_description"
            />

            <h6 class="ml-0 mt-4 mb-4">Resident Information</h6>

            <!-- First Name -->
            <p class="ml-0 mb-1 mt-3 text-muted">First Name</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="First name"
              v-model="request.req_contact_first"
            />

            <!-- Last Name -->
            <p class="ml-0 mb-1 mt-3 text-muted">Last Name</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Last name"
              v-model="request.req_contact_last"
            />

            <h6 class="ml-0 mt-4 mb-4">Contact Information</h6>

            <!-- Main Phone -->
            <p class="ml-0 mb-1 mt-3 text-muted">Main Phone</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Main phone"
              v-model="request.req_phone"
            />

            <!-- Email -->
            <p class="ml-0 mb-1 mt-3 text-muted">Email</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Email"
              v-model="request.req_email"
            />

            <!-- Address Single Line -->
            <p class="ml-0 mb-1 mt-3 text-muted">Pickup Address</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Address (location for pickup)"
              v-model="request.req_location"
              disabled
            />
          </div>

          <div class="modal-footer">
            <button
              @click="reset"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              @click="addProduct()"
              type="button"
              class="btn btn-primary"
              v-if="modal == 'new'"
            >
              Save
            </button>
            <button
              @click="updateProduct()"
              type="button"
              class="btn btn-primary"
              v-if="modal == 'edit'"
            >
              Update
            </button>
            <button
              @click="deleteProduct(request)"
              type="button"
              class="btn btn-primary btn-danger"
              v-if="modal == 'edit'"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="updateZone"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editLabel">Bulk Trash Request</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Assigned Zone -->
            <p>Update Zone of all selected rows</p>
            <p class="ml-0 mb-1 mt-3 text-muted">Assigned Zone</p>
            <input
              type="text"
              class="form-control mb-2"
              placeholder="Zone (leave blank if unsure)"
              v-model="req_zone_val"
            />
          </div>

          <div class="modal-footer">
            <button
              @click="reset"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              @click="updateSelectedItemsZone()"
              type="button"
              class="btn btn-primary"
            >
              Update Zone
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb, db } from "../firebase";
import { mapState, mapGetters } from "vuex";
import Vuetable from "vuetable-2";
import Pagination from "../components/design/Pagination.vue";
import { dbSchema } from "../store";

export default {
  name: "EmpMyRequests",
  components: { Vuetable, Pagination },
  props: [
    "requests",
    "handleSort",
    "startDate",
    "endDate",
    "type",
    "city",
    "shortTable",
    "unverified",
    "showExport",
    "csvExportFile",
  ],
  data() {
    return {
      req_zone_val: "",
      prop: "timestamp",
      loading: true,
      ascending: false,
      searchVal: "",
      page: 0,
      totalItemsPerPage: 20,
      filteredRequests: [],
      selectedLength: 0,
      previousLength: 0,
      selectedRequests: [],
      updateRequest: {
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
      },
      previousFilter: {},
      modal: "",
      request: {
        //Standard
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
        req_contact_first: null,
        req_contact_last: null,
        req_street: null,
        req_internal_addr: null,
        req_city: null,
        req_state: null,
        req_zip: null,
        req_street_name: null,
        req_street_number: null,
        req_submitted: null,
        timestamp: null,
      },
    };
  },
  computed: {
    maxPages() {
      const vals = this.getDataSize();
      var val = Math.ceil(vals / this.totalItemsPerPage);
      return val;
    },
    paginationInfo() {
      return {
        text: `<span><strong>${this.requests.length}</strong> requests , <strong>${this.totalItemsPerPage}</strong> per page</span>`,
        pageSize: this.totalItemsPerPage,
        nextPageText: "Next",
        prevPageText: "Prev",
      };
    },
    getAccountName(first, last) {
      return first + " " + last;
    },
    ...mapGetters({
      user: "user",
    }),
    ...mapState(["bulksettings", "bulkTypes"]),
  },
  created() {
    if (this.shortTable == true) {
      this.totalItemsPerPage = 10;
    }
  },
  methods: {
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return null;
    },
    selectedItemsCount() {
      return this.selectedRequests.length;
    },
    sortBulkTypes(bulkTypes, dropEmpty = false) {
      const emptyData = [];
      var types = bulkTypes.filter((item) => {
        if (item.name == "" || item.name == null) {
          emptyData.push(item);
          return false;
        }
        return true;
      });

      types = types.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();

        if (textA < textB) return -1;

        if (textA > textB) {
          return 1;
        }

        return 0;
      });

      if (!dropEmpty) return types.concat(emptyData);
      else {
        var removedEmpty = types.filter((item) => {
          if (item.message == "" || item.message == null) {
            return false;
          }

          if (item.pickup == "" || item.pickup == null) {
            return false;
          }

          return true;
        });

        return removedEmpty;
      }
    },
    getDataSize() {
      return this.filterData(this.requests).length;
    },
    onItemCountChange(e, i) {
      this.page = 0;
    },
    updatePage(page) {
      this.page = page;
    },
    toggleRowIsSelected(id) {
      if (this.isSelectedRow(id)) {
        const index = this.selectedRequests.indexOf(id);
        if (index > -1) {
          const resultArray = [...this.selectedRequests];
          const arr = resultArray.splice(index, 1);
          this.selectedRequests = resultArray;
        }
      } else {
        this.selectedRequests.push(id);
      }
    },
    isSelectedRow(id) {
      return this.selectedRequests.includes(id);
    },
    filterData(requests) {
      const dateCheck = (from, to, check) => {
        var fDate, lDate, cDate;
        fDate = Date.parse(from || "1970-01-01");
        lDate = Date.parse(to);
        cDate = Date.parse(check);

        if (cDate <= lDate && cDate >= fDate) {
          return true;
        }
        return false;
      };
      var dataSet = [].concat(requests);
      var filteredResult = dataSet;
      var endDate = null;
      if (this.endDate != null && this.endDate != "") {
        var [endYear, endMonth, endDay] = this.endDate.split("-");
        endDate = new Date(
          parseInt(endYear),
          parseInt(endMonth) - 1,
          parseInt(endDay) + 1
        );
        endDate.setHours(0, 0, 0, 0);
      }
      /* if(endDate < req_date)
                return false;*/
      var startDate = null;
      if (this.startDate != null && this.startDate != "") {
        var [startYear, startMonth, startDay] =
          this.startDate && this.startDate.split("-");
        var startDate = new Date(
          parseInt(startYear),
          parseInt(startMonth) - 1,
          parseInt(startDay)
        );
      }
      if (
        (this.startDate != null && this.startDate != "") ||
        (this.endDate != null && this.endDate != "")
      ) {
        var filteredResult = dataSet.filter((request) => {
          if (!request) return false;
          var req_date = new Date(request.timestamp);

          if (!dateCheck(startDate, endDate, req_date)) {
            return false;
          }

          return true;
        });
      }

      if (this.city) {
        filteredResult = filteredResult.filter((request) => {
          return request.req_city && request.req_city.includes(this.city);
        });
      }

      if (this.type) {
        filteredResult = filteredResult.filter((request) => {
          return request.req_type && this.type == request.req_type;
        });
      }

      filteredResult = filteredResult.filter((request) => {
        if (
          request.req_contact_first &&
          request.req_contact_first
            .toLowerCase()
            .includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_contact_last &&
          request.req_contact_last
            .toLowerCase()
            .includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_email &&
          request.req_email.toLowerCase().includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_description &&
          request.req_description
            .toLowerCase()
            .includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_phone &&
          request.req_phone.toLowerCase().includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_street_number &&
          request.req_street_number
            .toLowerCase()
            .includes(this.searchVal.toLowerCase())
        )
          return true;

        if (
          request.req_street_name &&
          request.req_street_name
            .toLowerCase()
            .includes(this.searchVal.toLowerCase())
        ) {
          return true;
        }

        return false;
      });

      if (this.unverified == true) {
        filteredResult = filteredResult.filter((request) => {
          return request.req_zone == null || request.req_zone == "";
        });
      }

      return filteredResult;
    },
    filterAndSortData(requests) {
      var sortedByTable = this.filterData(requests);

      if (this.ascending) {
        sortedByTable = sortedByTable.sort(function (a, b) {
          return Date.parse(a.timestamp) - Date.parse(b.timestamp);
        });
      } else {
        sortedByTable = sortedByTable.sort(function (a, b) {
          return Date.parse(b.timestamp) - Date.parse(a.timestamp);
        });
      }

      return sortedByTable;
    },
    copyRequest(request) {
      // Nothing to put here yet.
      this.request = request;
      var date = new Date();
      var options = {
        weekday: "short",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };

      options.timeZone = "America/New_York";
      this.request.timestamp = date.toLocaleDateString("en-US", options);
      this.request.req_status = "Submitted";
      db.collection(dbSchema.users)
        .doc(this.user.id)
        .collection(dbSchema.requests)
        .add(this.request);
      Toast.fire({
        type: "success",
        title: "Bulk Trash Request Added",
      });
      $("#product").modal("hide");
      this.reset();
    },
    clearSelectedItems() {
      this.selectedRequests = [];
    },
    curateData(requests) {
      var sortedByTable = this.filterAndSortData(requests);

      /*result = result.filter((request) => {
        return request.req_zone != null && request.req_type == "Bulk";
      });*/
      var reduceItems = sortedByTable.splice(
        this.page * this.totalItemsPerPage,
        this.totalItemsPerPage
      );
      this.loading = false;
      return reduceItems;
    },
    async deleteSelectedItems() {
      var totalRequest = Array.isArray(this.selectedRequests)
        ? this.selectedRequests.length
        : 0;
      if (totalRequest == 0) {
        Swal.fire({
          title: `No Requests Selected`,
          text: "There is nothing currently selected to delete!",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        }).then(() => {});
        return;
      }

      var documentList = [];
      await this.selectedRequests.forEach((selectedItem) => {
        documentList.push(selectedItem);
      });

      var requestsRef = await db.collectionGroup("requestz").get();

      const handleDelete = async (result) => {
        if (result.value) {
          try {
            var objects = requestsRef.docs.filter((item) => {
              return documentList.includes(item.id);
            });
            objects.forEach(async (doc) => {
              await doc.ref.delete();
            });
            $("#product").modal("hide");
          } catch (e) {
          } finally {
            const toast = (() => {
              this.selectedRequests = [];
              Toast.fire({
                type: "error",
                title: "Bulk Trash Request Deleted",
              });
            }).bind(this);
            setTimeout(toast, 400);
          }
        }
      };

      Swal.fire({
        title: `Delete ${totalRequest} ${
          totalRequest > 1 ? "requests" : "request"
        }?`,
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(handleDelete);
    },
    async deleteProduct(doc) {
      const requestsRef = await db.collectionGroup("requestz").get();

      const handleDelete = async (result) => {
        if (result.value) {
          var deleteError = false;
          let arrayResult = await requestsRef.docs.filter((item) => {
            return item.id == doc.id;
          });
          try {
            await arrayResult.forEach(async (doc) => {
              await doc.ref.delete();
            });
          } catch (e) {
            deleteError = true;
            Toast.fire({
              type: "error",
              title: "Error Occured While Deleting",
            });
          } finally {
            if (!deleteError) {
              Toast.fire({
                type: "error",
                title: "Bulk Trash Request Deleted",
              });
              $("#product").modal("hide");
              //setTimeout(() => this.$router.go(), 600)
            }
          }
        }
      };
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(handleDelete);
    },
    exportRequests() {
      Swal.fire({
        title: "Exports include all columns",
        text: "The csv export generated will include more than the columns featured in the data presentation on screen.",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Export Data",
      }).then(this.csvExport);
    },
    editProduct(request) {
      this.modal = "edit";
      this.request = request;
      const { id, req_type, req_location, req_zone, req_description } = request;
      this.updateRequest = request;
      $("#product").modal("show");
    },
    async updateProduct() {
      const groupData = await db.collectionGroup("requestz").get();

      groupData.docs.forEach(async (doc) => {
        if (this.request.id == doc.id) {
          await doc.ref.update(this.request);
        }
      });
      Toast.fire({
        type: "success",
        title: "Bulk Trash Request Updated",
      });
      $("#product").modal("hide");
      this.reset();
    },
    reset() {
      this.request = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
      };
    },
    csvExport(result) {
      console.log(result)

      if(!result)
        return;

      if(result.dismiss != undefined || result.dismiss != null)
        return;

      var arrData = this.filterAndSortData(this.requests);
      var managedDataSet = [];

      arrData.forEach((item) => {
        managedDataSet.push({
          Requested: item.timestamp,
          Name: item.req_contact_first + " " + item.req_contact_last,
          Email: item.req_email,
          Phone: this.formatPhoneNumber(item.req_phone),
          Type: item.req_type,
          "Desc.": item.req_description,
          House: item.req_street_number,
          Street: item.req_street_name,
          City: item.req_city,
          Zipcode: item.req_zip,
          Zone: item.req_zone,
        });
      });
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(managedDataSet[0]).join(","),
        ...managedDataSet.map((item) => {
          var output = Object.values(item).join('","');
          return '"' + output + '"';
        }),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const date = new Date().toISOString().slice(0, 10);
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute(
        "download",
        (this.csvExportFile || "export_requests") + "_" + date + ".csv"
      );
      link.click();
    },
    showUpdateZone() {
      var totalRequest = Array.isArray(this.selectedRequests)
        ? this.selectedRequests.length
        : 0;

      if (totalRequest == 0) {
        Swal.fire({
          title: `No Requests Selected`,
          text: "There is nothing currently selected to update!",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        }).then(() => {});
        return;
      } else {
        $("#updateZone").modal("show");
      }
    },
    async updateSelectedItemsZone() {
      var totalRequest = Array.isArray(this.selectedRequests)
        ? this.selectedRequests.length
        : 0;
      if (totalRequest == 0) {
        Swal.fire({
          title: `No Requests Selected`,
          text: "There is nothing currently selected to update!",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        }).then(() => {});
        return;
      }

      var documentList = [];
      await this.selectedRequests.forEach((selectedItem) => {
        documentList.push(selectedItem);
      });

      var requestsRef = await db.collectionGroup("requestz").get();

      const handleUpdate = async (result) => {
        if (result.value) {
          try {
            var objects = requestsRef.docs.filter((item) => {
              return documentList.includes(item.id);
            });
            objects.forEach(async (doc) => {
              await doc.ref.set(
                { req_zone: this.req_zone_val },
                { merge: true }
              );
            });
            $("#updateZone").modal("hide");
          } catch (e) {
          } finally {
            const toast = (() => {
              this.selectedRequests = [];
              Toast.fire({
                type: "success",
                title: "Bulk Trash Requests Update",
              });
            }).bind(this);
            setTimeout(toast, 400);
          }
        }
      };

      Swal.fire({
        title: `Update ${totalRequest} ${
          totalRequest > 1 ? "requests" : "request"
        }?`,
        text: "You will have to manually revert this change if you need to undo it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update zones!",
      }).then(handleUpdate);
    },
  },
};
</script>

<style scoped lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
